// Работа с полями формы. Добавление классов, работа с placeholder

const formsOld = {
    form: () => {
        const forms = document.querySelectorAll('._form'),
            inputs = document.querySelectorAll('._form-input');

        if (forms.length) {
            const message = {
                uk: {
                    loading: 'Відправка...',
                    success: 'Надіслано! Ми скоро зв\'яжемося з Вами',
                    failure: 'Щось пішло не так',
                    fill_in_field: 'Заповніть, будь ласка, поля'
                },
                en: {
                    loading: 'Sending...',
                    success: 'Sent! We will contact you soon',
                    failure: 'Something went wrong',
                    fill_in_field: 'Please fill in the fields'
                },
                ru: {
                    loading: 'Отправка...',
                    success: 'Отправлено! Мы скоро свяжемся с Вами',
                    failure: 'Что-то пошло не так',
                    fill_in_field: 'Пожалуйста, заполните поля'
                }
            }
            let lang = document.documentElement.lang;
            if (lang === 'ru-RU') {
                lang = 'ru';
            }
            if (lang === 'en-US') {
                lang = 'en';
            }
            if (lang === 'uk-UA') {
                lang = 'ua';
            }
            const textStringsLang = message[lang];

            const formAddError = (field) => {
                field.classList.add('_error');
            }

            const formRemoveError = (field) => {
                field.classList.remove('_error');
            }

            const emailCheck = (field) => {
                return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(field.value);
            }

            const phoneCheck = (field) => {
                return /^(\+3|3|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/.test(field.value);
            }


            function formValidate(form) {
                let error = 0;

                const phoneInputs = form.querySelectorAll('._form-phone'),
                    emailInputs = form.querySelectorAll('input[type="email"]'),
                    reqInputs = form.querySelectorAll('._req');
                form.querySelectorAll('input').forEach(input => {
                    formRemoveError(input);
                });

                if (phoneInputs) {
                    phoneInputs.forEach(item => {
                        item.addEventListener('input', () => {
                            item.value = item.value.replace(/\D/, '');
                        });
                        if (phoneCheck(item)) {
                            formAddError(item);
                            error++;
                        }
                    })
                }

                if (emailInputs) {
                    emailInputs.forEach(item => {
                        if (emailCheck(item)) {
                            formAddError(item);
                            error++;
                        }
                    })
                }

                if (reqInputs) {
                    reqInputs.forEach(item => {
                        if (item.value === '') {
                            formAddError(item);
                            error++;
                        }
                    })
                }
                return error;
            }

            const postData = async (url, data) => {
                //console.log(data)

                let result = await fetch(url, {
                    method: 'POST',
                    body: data
                });

                return await result.text();
            }

            const clearInputs = () => {
                inputs.forEach(item => {
                    item.value = '';
                    item.setAttribute('value', '');
                })
            }

            forms.forEach(item => {

                const policy = item.querySelector('[name="policy"]');

                if (policy) {
                    item.querySelector('[type="submit"]').disabled = true;
                    policy.addEventListener('click', () => {
                        if (policy.checked) {
                            item.querySelector('[type="submit"]').disabled = false;
                        } else {
                            item.querySelector('[type="submit"]').disabled = true;
                        }
                    });
                }

                item.addEventListener('submit', (e) => {
                    if (item.classList.contains('_pwm-send')) {
                        e.preventDefault();

                        let statusMessage = document.createElement('div');
                        statusMessage.classList.add('_form__status');

                        // if isset element FormStatus = remove
                        if (item.querySelector('._form__status')) {
                            item.querySelector('._form__status').remove();
                        }

                        item.appendChild(statusMessage);

                        let formStatus = item.querySelector('._form__status');
                        formStatus.classList.remove('_form__status-error');
                        formStatus.classList.remove('_form__status-ok');
                        statusMessage.textContent = textStringsLang.loading;

                        let error = formValidate(item);

                        //console.log(error);
                        if (error === 0) {
                            const formData = new FormData(item);

                            postData(`/wp-content/themes/excursions/sendmail.php`, formData)
                                .then(result => {
                                    console.log(result)
                                    item.classList.add('_ok');
                                    statusMessage.classList.remove('_form__status-error');
                                    statusMessage.classList.add('_form__status-ok');
                                    statusMessage.textContent = textStringsLang.success;

                                })
                                .catch(() => {
                                    statusMessage.classList.add('_form__status-error');
                                    statusMessage.textContent = textStringsLang.failure;

                                    clearInputs();

                                })
                                .finally(() => {
                                    clearInputs();
                                });
                        } else {
                            statusMessage.classList.add('_form__status-error');
                            statusMessage.textContent = textStringsLang.fill_in_field;

                            item.addEventListener('input', () => {
                                error = formValidate(item);
                            })
                        }
                    }
                })
            })

        }
    }

}


/**
 * 1. Вибрати всі, крім (по імені)
 * 2. Валідувати чи ні (валідація може бути і в php)
 * 3. Відправляти чи ні
 * 4. Шлях до php файлу
 * 5. Відправляти в телеграм із скрипта, без відправки на пошту
 * 6. Маска телефону
 * 7. Перевірка правильності E-mail
 * 8. Перевірка на заповнення
 * 9. Перевірка на роботів
 * 10. Перевірка телефону
 * 11. Сповіщення про відправку тут же, в модалці, на новій сторінці (вказати урл)
 * 12. Відправляти у вайбер
 * 13. Чекбокси політики конфіденційності - перевірка
 * 14. Функція після успішної відправки (для додаткових приколів, типу слідкування з гуглтегів)
 * 
 * Так що це потрібно переписати, як модуль з класомі
 */
/*const forms = {
    sendForm: (not) => {
        console.log('Smile :)');
        const forms = document.forms;
        console.log(forms);
        if (forms.length) {
            for (const form of forms) {
                //if (form.getAttribute('name') != not) {
                //if (!not.indexOf(form.getAttribute('name'))) {
                console.log(form.getAttribute('name'));
                form.addEventListener('submit', e => {
                    const form = e.target;
                    //formSubmitAction(form, e);
                });
                form.addEventListener('reset', e => {
                    const form = e.target;
                    //formValidate.formClean(form);
                });
                //}
            }
        }
    },
}*/

export const form = formsOld.form;
//export const sendForm = forms.sendForm;